import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-8",
  "aria-label": "Social links"
}
const _hoisted_2 = { class: "flex flex-row items-center gap-4" }
const _hoisted_3 = ["href", "aria-label"]

import { computed } from "vue";
import { Social } from "@/types/socialType";


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialSection',
  props: {
    socials: {}
  },
  setup(__props: any) {

const props = __props;

const socialList = computed(() => {
  return props.socials || [];
});

const hasSocials = computed(() => socialList.value.length > 0);

const ICON_PREFIXES: { [key: string]: string } = {
  fa: "fab",
  fas: "fas",
  si: "si",
};

function getIconPrefix(provider: string): string {
  return ICON_PREFIXES[provider] || "fas";
}

function getIconName(name: string): string {
  return name.replace("fa-", "");
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (hasSocials.value)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialList.value, (social) => {
            return (_openBlock(), _createElementBlock("li", {
              key: social._id
            }, [
              _createElementVNode("a", {
                href: social.link,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "flex items-center justify-center w-10 h-10 rounded-full text-stone-500 dark:text-stone-500 hover:text-brand-700 dark:hover:text-brand-200 hover:bg-brand-50 dark:hover:bg-brand-900/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400/70 dark:focus-visible:ring-brand-500/70 transition-all duration-200",
                "aria-label": social.name || 'Social link'
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: [
              getIconPrefix(social.icon.provider),
              getIconName(social.icon.name),
            ],
                  class: "w-5 h-5"
                }, null, 8, ["icon"])
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})